import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { DocumentService } from 'src/app/services/document.service';
import { HttpRequestsService } from 'src/app/services/http-requests.service';
import { MainDialogComponent } from '../dialogComponents/main dialog/main-dialog.component';
import { MapsAPILoader } from '@agm/core';
import { UsecaseLocationComponent } from '../dialogComponents/usecaseLocation.component';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
})
export class SearchComponent implements OnInit {
  public results: any = [];
  public docCountries: any = [];
  public docKeywords: any = [];
  public docTypes: any = [];
  public docDurationFrom: any = [];
  public docDurationTo: any = [];
  public docLearning: any = [];
  public showResults: boolean = false;
  public searchArray: any;
  public viewDocument: any;
  public userPreferences: any[] = [];
  public updatePref: boolean = false;
  public showPref: boolean = false;
  public filterCountry: any;
  public filterDurationFrom: any;
  public filterDurationTo: any;
  public filterKeywords: any;
  public filterCategory: any;
  public filterLearning: any;
  public unFilteredResults: any[] = [];
  public filter = false;
  public count: number;
  public noResults: boolean = false;
  public loading: boolean = true;
  public showSuggestions: boolean = false;
  public showModerator: boolean;
  public locations: any[] = [];
  public dataObj: any = [];
  public ids: any = [];

  constructor(
    private req: HttpRequestsService<any>,
    private router: Router,
    private doc: DocumentService,
    public dialog: MatDialog,
    public mapsApiLoader: MapsAPILoader,
    private keycloak: KeycloakService
  ) { }

  ngOnInit() {
    this.getLocations();
    this.getFiles();
    if (this.keycloak.getUserRoles().includes('MODERATOR')) {
      this.showModerator = true;
    } else {
      this.showModerator = false;
    }
    this.count = 0;
  }

  getFiles() {
    this.loading = true;
    this.req.getAllFiles().subscribe(res => {
      this.results = res.sort((a, b) => a.title.localeCompare(b.title));
      this.unFilteredResults = [...this.results];
      this.populateFilters(this.results);
      this.loading = false;
    });
  }  

  getLocations() {
    this.req.getLocations().subscribe(
      (data) => {
        this.locations = data;
        this.locations.forEach((element) => {
          this.ids.push(element.id);
        });

      },
      (error) => console.log(error),
      () => {
        this.getMapData();
      }
    );
    this.showResults = true;
  }

  getMapData() {
    this.locations.forEach((element) => {
      if (element.coordinates.lat != null && element.coordinates.lng != null) {
        this.dataObj.push({
          latitude: element.coordinates.lat,
          longitude: element.coordinates.lng,
          title: element.title,
          id: element.id
        });
      }
    });
  }

  openMap() {
    this.router.navigate(['/Showcases']);
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = { data: this.dataObj };
    this.dialog.open(MainDialogComponent, {
      disableClose: true,
      width: '1100px',
      height: '650px',
      minWidth: '50px',
      minHeight: '50px',
      maxWidth: '1200px',
      maxHeight: '900px',
      data: { component: UsecaseLocationComponent, dialogConfig },
    });
  }

  onSearchKeypress(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.applySearch();
    }
  }

  applySearch() {
    this.loading = true;
    this.req.getDocuments(this.searchArray).subscribe((res) => {
      this.results = res.sort((a, b) => a.title.localeCompare(b.title));
      this.unFilteredResults = [...this.results];
      this.populateFilters(this.results);
      this.loading = false;
    });
  }
  
  populateFilters(results) {
    this.docCountries = [];
    this.docKeywords = [];
  
    const keywordSet = new Map();
  
    results.forEach((element) => {
      if (element.keywords && typeof element.keywords === 'string') {
        element.keywords = element.keywords
          .split(/[,;]\s*/)
          .map((kw) => kw.trim());
      }
  
      if (element.country && !this.docCountries.includes(element.country)) {
        this.docCountries.push(element.country);
      }

      if (element.keywords && element.keywords.length > 0) {
        element.keywords.forEach((kw) => {
          const lowercaseKw = kw.toLowerCase();
          if (!keywordSet.has(lowercaseKw)) {
            keywordSet.set(lowercaseKw, kw);
          }
        });
      }
    });
  
    this.docKeywords = Array.from(keywordSet.values());
  
    if (!this.docCountries.includes('All')) {
      this.docCountries.unshift('All');
    }
    if (!this.docKeywords.includes('All')) {
      this.docKeywords.unshift('All');
    }
  
    this.docCountries = ['All', ...this.docCountries.slice(1).sort((a, b) => a.localeCompare(b))];
    this.docKeywords = ['All', ...this.docKeywords.slice(1).sort((a, b) => a.localeCompare(b))];
  }
  
  applyFilter() {
    let filteredResults = [...this.unFilteredResults];
  
    if (this.filterCountry && this.filterCountry !== 'All') {
      filteredResults = filteredResults.filter(
        (result) => result.country && result.country.toLowerCase() === this.filterCountry.toLowerCase()
      );
    }
  
    if (this.filterKeywords && this.filterKeywords !== 'All') {
      filteredResults = filteredResults.filter(
        (result) =>
          result.keywords &&
          result.keywords.some((kw) => kw.toLowerCase() === this.filterKeywords.toLowerCase())
      );
    }
  
    this.results = filteredResults.sort((a, b) => a.title.localeCompare(b.title));
  }
  
  resetFilters() {
    this.results = [...this.unFilteredResults];
    this.filterCountry = "All";
    this.filterKeywords = "All";
  }

  goToView(id) {
    this.req.getDocument(id).subscribe(
      (res) => {
        this.viewDocument = res[0];
      },
      (error) => console.log(error),
      () => {
        this.doc.data = this.viewDocument;
        this.router.navigate(['ViewDocument']);
      }
    );
  }
}